import { createContext, Component } from "react";
import classNames from "classnames";
import styled from "styled-components";
import { rgba } from "polished";

import { withTooltip } from "common/components/tooltip";

const ButtonSwitchContext = createContext();

export class ButtonSwitch extends Component {
    static defaultProps = {
        className: "button-switch",
        defaultButtonClassnames: ["btn"],
        activeButtonClassnames: ["active"]
    };

    static Button = ({ children, ...rest }) => (
        <ButtonSwitchContext.Consumer>
            {({ defaultButtonClassnames, activeButtonClassnames, activeValue }) => {
                const button = (
                    <button
                        key={rest.value}
                        value={rest.value}
                        type="button"
                        className={classNames(defaultButtonClassnames, rest.value === activeValue ? activeButtonClassnames : null, rest.className)}
                        onClick={rest.onClick}
                    >{children}
                    </button>
                );
                return rest.tooltip ? withTooltip(button, { skipWrapper: true, title: rest.tooltip }) : button;
            }}
        </ButtonSwitchContext.Consumer>
    );

    static Separator = () => <div className="separator" />;

    render() {
        const { defaultButtonClassnames, activeButtonClassnames, activeValue } = this.props;
        return (
            <ButtonSwitchContext.Provider value={{ defaultButtonClassnames, activeButtonClassnames, activeValue }}>
                <BaseStyles >
                    {this.props.children}
                </BaseStyles>
            </ButtonSwitchContext.Provider>
        );
    }
}

const BaseStyles = styled.div(({ theme: { fontSizeLarge, colors } }) => `
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    height: 32px;

    .btn {
        padding: 6px 8px;
        outline: none;
        border-top-width: 1px;
        border-bottom-width: 1px;
        border-left-width: 1px;
        border-right-width: 0;
        border-styled: solid;
        color: ${colors["grey-wcag-6B6"]};
        border-color: ${colors["paz-black-l-30"]};
        background-color: ${colors["canvas-white"]};
        min-width: 26px;
        height: 100%;
        
        &:first-child:not(:last-child) {
            border-radius: 3px 0 0 3px;
        }
        &:last-child:not(:first-child) {
            border-right-width: 1px;
            border-radius: 0 3px 3px 0;
        }

        &:not(:last-child):not(:first-child) {
            border-radius: 0;
        }

        &:last-child:first-child {
            border-right-width: 1px;
        }
        
        &:hover, &:focus {
            background-color: ${colors["canvas-dark"]};
        }

        &.active + .btn {
            border-left-width: 0;
        }

        &.active {
            border-right-width: 1px;
            border-left-width: 1px;
            color: ${colors["blue-wcag-327"]};
            border-color: ${colors["blue-wcag-327"]};
            background-color: ${colors["blue-tint"]};
            box-shadow: inset 0px 3px 5px 0px ${rgba(colors["blue-wcag-327"], 0.2)};

            &:not(:last-child):not(:first-child) {
                border-radius: 0;
            }
        }

        &.button-with-icon-and-text {
            display: flex;
            flex-direction: row;
            gap: 6px;
            padding-left: 7px;
            padding-right: 10px;
        }

        span {
            line-height: 20px;
            font-size: 23px;
            transform: translate(0, 0);
        }

        svg {
            height: 20px;
            width: 20px;
        }
    }
`);
